export default __webpack_public_path__ + "static/media/section-malvorlagen.ac6a78b0.png";